<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component({})
    export class SearchProgressNote extends Vue {
        render() {
            return null
        }
    }

    export default SearchProgressNote
</script>
